







































import {Component, Vue} from "vue-property-decorator";
import DeleteButton from "@/components/datatable/DeleteButton.vue";
import EForm from "@/components/datatable/EForm.vue";
import Number from "@/components/inputs/Number.vue";
import TextField from "@/components/inputs/TextField.vue";
import Id from "@/components/inputs/Id.vue";
import SeoText from "@/components/inputs/SeoText.vue";
import Editor from '@tinymce/tinymce-vue';
import {ActionsEnum} from "@/entity/ActionsEnum";
import Seo from "@/components/inputs/Seo.vue";
import {PageTypeEnum} from "@/entity/PageTypeEnum";
import PageEntity from "@/entity/PageEntity";
import RichTextEditor from "@/components/RichTextEditor.vue";

@Component({
  components: {
    RichTextEditor,
    Seo,
    DeleteButton,EForm,Number,TextField,Id,SeoText,Editor
  }
})
export default class Programlar extends  Vue{
  items : PageEntity[] | null= null;
  dialog = false;
  title:string = "";
  search: string = "";
  baseAction:string = ActionsEnum.Pages;
  qs:string= "?type="+ PageTypeEnum.Programlar;
  action:string = this.baseAction;
  data : PageEntity = new PageEntity();
  headers = [
    {
      text: "Id",
      align: "start",
      sortable: true,
      value: "page_id"
    },
    {text: "Başlık", value: "title"},
    {text: "Başlık En", value: "title_en"},
    {text: "Url", value: "name"},
    {text: "İşlemler", value: "actions"}
  ];
  edit(item:PageEntity){
    this.$store.dispatch("go","/genel/sayfa/Programlar/"+item.page_id);
  }
  add(){
    this.$store.dispatch("go","/genel/sayfa/Programlar/ekle");
  }
  async get(){
    this.dialog = false;
    let response = await this.$http.get(this.baseAction + this.qs);
    this.items = response.data;
  }
  created(){
    this.get();
  }
};
